module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/particular06-bc87656f46cfd171d5c104078c39380a.png";